import { useMemo } from "react";

import useImage from "../../../api/api-hooks/images/useImage";
import { pathnameFromURL } from "../../../utils/GeneralUtils";
import Constants from "../../../utils/Constants";

interface Props {
  imageRecord: any;
  initials?: string;
  size?: "xs" | "sm" | "md" | "lg";
  color?: string;
  className?: string;
  withBorder?: boolean;
}

function getSizeValue(size: string | undefined) {
  if (size === "sm") return 26;
  if (size === "md") return 32;
  if (size === "lg") return 40;

  return 26;
}

function getFontSize(size: string | undefined) {
  if (size === "sm") return 10;
  if (size === "md") return 12;
  if (size === "lg") return 14;

  return 10;
}

const ThumbnailAvatar = ({
  imageRecord,
  initials,
  size,
  color,
  className,
  withBorder = true,
}: Props) => {
  const pathname = useMemo(() => {
    if (imageRecord?.PublicURL) return imageRecord?.PublicURL;
    if (imageRecord?.File) return imageRecord?.File;
    if (imageRecord?.URL) return pathnameFromURL(imageRecord?.URL);

    return "";
  }, [imageRecord?.File, imageRecord?.URL, imageRecord?.PublicURL]);

  const { fileURL: privateFileUrl } = useImage(pathname);

  color = color ? color : Constants.THEME.SUPERLIGHT;
  const fileURL = imageRecord?.PublicURL ? pathname : privateFileUrl;
  const sizeValue = getSizeValue(size);
  const fontSize = getFontSize(size);

  if (!fileURL) {
    return (
      <span
        className={`${
          withBorder ? "tw:border tw:border-light" : ""
        } tw:mr-2 tw:flex tw:items-center tw:justify-center tw:rounded-full tw:font-normal ${className}`}
        style={{
          height: sizeValue,
          width: sizeValue,
          backgroundColor: color,
          fontSize: fontSize,
        }}
      >
        {initials}
      </span>
    );
  }

  return (
    <img
      className={`tw:mr-2 ${
        withBorder ? "border" : ""
      } tw:object-cover tw:rounded-full ${className}`}
      style={{ width: sizeValue, height: sizeValue }}
      src={fileURL}
      alt={imageRecord?.AltText ? imageRecord?.AltText : "Profile Image"}
    />
  );
};

export default ThumbnailAvatar;
